import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useChatbotStore, useUserStore, useUtmStore, useChatStateStore, useMessagesStore, useFormStore } from "../../zustand/store";
import { useChatbot } from "../../services/queries/chatbotQueries";
import { handleErrorRedirect } from "../../utils/errorCodeHandler";
import { LayoutModeEnum } from "../../type/modeState.type";

const Transaction = () => {
    const navigate = useNavigate();
    const queryString = window.location.search;
    const [searchParams, setSearchParams] = new useSearchParams(queryString);
    const partnerType = useParams().partnerType;
    const partnerId = searchParams.get('ptid');
    const chatUserId = searchParams.get('cuid') || parseInt(Math.random()*1e9);
    const displayLocation = searchParams.get('dp');
    const displayItemId = searchParams.get('it');
    const isConsole = searchParams.get('isConsole') === 'true';
    const isBuilder = searchParams.get('isBuilder');
    const layoutMode = searchParams.get('mode');
    const nullLang = searchParams.get('lang') === 'null' || searchParams.get('lang') === null;
    const language = nullLang ? partnerType === 'shopify' ? 'en' : 'ko' : searchParams.get('lang');
    const variant = searchParams.get('variant') || null;
    // fastfive 시나리오 진입 키. URL ?entry=<key> 로 직접 진입하거나, SDK 에서 postMessage 로도 가능.
    const entryScenarioKey = searchParams.get('entry');
    const utm = {
        source: searchParams.get('utms'),
        medium: searchParams.get('utmm'), 
        campaign: searchParams.get('utmca'),
        content: searchParams.get('utmco'),
        term: searchParams.get('utmt'),
        transitionPage: searchParams.get('tp'),
    };
    // const isFF = false;
    const isFF = (partnerId === '6756ad3d3aaf5b928eec329b') 
        || (partnerId ==='67615284c5ff44110dbc6613')
        || (partnerId === '67516ecf103e7e29c75a621e');

    const { setPartnerId, setPartnerType, setChatUserId } = useUserStore();
    const { setChatbot } = useChatbotStore();
    const {
        setIsConsole,
        setDisplayLocation,
        setDisplayItemId,
        setLanguage,
        setLayoutMode,
        setAddToCartWithOption,
        setVariant,
        setFastfiveScenarioId,
        clearFastfiveScenarioId,
        setIsPreAnswered,
    } = useChatStateStore();
    const { clearPreAnswersObject } = useFormStore();
    const { setUtmParams } = useUtmStore();
    const { data: chatbot, isLoading, error } = useChatbot(partnerId);

    useEffect(() => {
        setPartnerId(partnerId);
        setPartnerType(isFF ? 'fastfive' : partnerType);
        setChatUserId(chatUserId);
        setDisplayLocation(displayLocation);
        setDisplayItemId(displayItemId);
        setIsConsole(isConsole);
        setUtmParams(utm);
        setLanguage(language);
        setLayoutMode(layoutMode === LayoutModeEnum.MODAL ? LayoutModeEnum.MODAL : LayoutModeEnum.DEFAULT);
        setAddToCartWithOption(((layoutMode === LayoutModeEnum.MODAL) && (partnerType === 'cafe24')) ? true : false);
        setVariant(variant);

        // fastfive 자동 진입: URL ?entry=<key> 가 있으면 해당 시나리오로 바로 들어감.
        // - 유효성 검증은 시나리오 fixture/API 와 비교가 필요하지만, 여기서는 단순히 set 만 함.
        //   잘못된 key 면 Chat.jsx 의 selectedScenario === null self-healing 으로 entry 버튼이 다시 노출됨.
        // - 항상 isPreAnswered 를 false 로 리셋해서 PreQuestion 이 처음부터 실행되도록 보장.
        if (isFF) {
            if (entryScenarioKey) {
                // URL ?entry= 로 진입 → auto-entered=true (scenario greeting 노출 대상)
                // 시나리오가 실제로 바뀔 때만 진행 중인 사전질문 답변을 버린다.
                if (entryScenarioKey !== useChatStateStore.getState().fastfiveScenarioId) {
                    clearPreAnswersObject();
                }
                setFastfiveScenarioId(entryScenarioKey, true);
                setIsPreAnswered(false);
            } else if (
                useMessagesStore.getState().messages.length === 0
                && useChatStateStore.getState().isFormSubmitted !== 'ready'
            ) {
                // messages 가 있으면 entry 뷰가 어차피 안 뜨므로, 여기서 지우면 scenarioKey 만 유실된다.
                clearFastfiveScenarioId();
                setIsPreAnswered(false);
                clearPreAnswersObject();
            }
        }

        if (chatbot && !isLoading) {
            setChatbot(chatbot);
            let chatUrl;
            if (partnerType === 'dlst') {
                chatUrl = `/dlst/${chatUserId}`; 
            } else {
                chatUrl = `/chat/${chatbot.chatbotId}/${chatUserId}`;
            }
            navigate(chatUrl, { replace: true });
        }
    }, [chatbot])

    // Handle errors from useChatbot hook
    useEffect(() => {
        if (error) {
            handleErrorRedirect(error);
        }
    }, [error])
}

export default Transaction;